"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_TRAIL_LABEL = exports.isAllowEmptyEnum = exports.getEnumText = exports.getEnumOptions = void 0;
var enum_1 = require("remota-common/enum");
var util_1 = require("remota-common/util");
var translate_1 = require("remota-common/util/translate");
var fat_1 = require("remota-common/util/fat");
var englishCurrencies = [
    { text: "AED (United Arab Emirates Dirham)", value: enum_1.PaidCurrency.AED },
    { text: "AUD (Australian Dollar)", value: enum_1.PaidCurrency.AUD },
    { text: "BDT (Bangladeshi Taka)", value: enum_1.PaidCurrency.BDT },
    { text: "BRL (Brazilian Real)", value: enum_1.PaidCurrency.BRL },
    { text: "CAD (Canadian Dollar)", value: enum_1.PaidCurrency.CAD },
    { text: "CHF (Swiss Franc)", value: enum_1.PaidCurrency.CHF },
    { text: "CNY (Chinese Yuan)", value: enum_1.PaidCurrency.CNY },
    { text: "DKK (Danish Krone)", value: enum_1.PaidCurrency.DKK },
    { text: "EUR (Euro)", value: enum_1.PaidCurrency.EUR },
    { text: "GBP (British Pound)", value: enum_1.PaidCurrency.GBP },
    { text: "HKD (Hong Kong Dollar)", value: enum_1.PaidCurrency.HKD },
    { text: "HUF (Hungarian Forint)", value: enum_1.PaidCurrency.HUF },
    { text: "IDR (Indonesian Rupiah)", value: enum_1.PaidCurrency.IDR },
    { text: "INR (Indian Rupee)", value: enum_1.PaidCurrency.INR },
    { text: "JPY (Japanese Yen)", value: enum_1.PaidCurrency.JPY },
    { text: "KRW (South Korean Won)", value: enum_1.PaidCurrency.KRW },
    { text: "MXN (Mexican Peso)", value: enum_1.PaidCurrency.MXN },
    { text: "MYR (Malaysian Ringgit)", value: enum_1.PaidCurrency.MYR },
    { text: "NOK (Norwegian Krone)", value: enum_1.PaidCurrency.NOK },
    { text: "NZD (New Zealand Dollar)", value: enum_1.PaidCurrency.NZD },
    { text: "PHP (Philippine Peso)", value: enum_1.PaidCurrency.PHP },
    { text: "PLN (Polish Zloty)", value: enum_1.PaidCurrency.PLN },
    { text: "RUB (Russian Ruble)", value: enum_1.PaidCurrency.RUB },
    { text: "SEK (Swedish Krona)", value: enum_1.PaidCurrency.SEK },
    { text: "SGD (Singapore Dollar)", value: enum_1.PaidCurrency.SGD },
    { text: "THB (Thai Baht)", value: enum_1.PaidCurrency.THB },
    { text: "TRY (Turkish Lira)", value: enum_1.PaidCurrency.TRY },
    { text: "TWD (Taiwan Dollar)", value: enum_1.PaidCurrency.TWD },
    { text: "USD (United States Dollar)", value: enum_1.PaidCurrency.USD },
    { text: "VND (Vietnamese Dong)", value: enum_1.PaidCurrency.VND },
    { text: "ZAR (South African Rand)", value: enum_1.PaidCurrency.ZAR },
];
var japaneseCurrencies = [
    { text: "JPY (日本・円)", value: enum_1.PaidCurrency.JPY },
    { text: "USD (アメリカ合衆国ドル)", value: enum_1.PaidCurrency.USD },
    { text: "EUR (ユーロ)", value: enum_1.PaidCurrency.EUR },
    { text: "CNY / RMB (中国・人民元)", value: enum_1.PaidCurrency.CNY },
    { text: "HKD (香港ドル)", value: enum_1.PaidCurrency.HKD },
    { text: "--------------------", value: "--------------------", disabled: true },
    { text: "AED (UAEディルハム)", value: enum_1.PaidCurrency.AED },
    { text: "AUD (オーストラリア・ドル)", value: enum_1.PaidCurrency.AUD },
    { text: "BDT (バングラデシュ・タカ)", value: enum_1.PaidCurrency.BDT },
    { text: "BRL (ブラジル・レアル)", value: enum_1.PaidCurrency.BRL },
    { text: "CAD (カナダ・ドル)", value: enum_1.PaidCurrency.CAD },
    { text: "CHF (スイス・フラン)", value: enum_1.PaidCurrency.CHF },
    { text: "DKK (デンマーク・クローネ)", value: enum_1.PaidCurrency.DKK },
    { text: "GBP (スターリング・ポンド)", value: enum_1.PaidCurrency.GBP },
    { text: "HUF (ハンガリー・フォリント)", value: enum_1.PaidCurrency.HUF },
    { text: "IDR (インドネシア・ルピア)", value: enum_1.PaidCurrency.IDR },
    { text: "INR (インド・ルピー)", value: enum_1.PaidCurrency.INR },
    { text: "KRW (大韓民国ウォン)", value: enum_1.PaidCurrency.KRW },
    { text: "MXN (メキシコ・ペソ)", value: enum_1.PaidCurrency.MXN },
    { text: "MYR (マレーシア・リンギット)", value: enum_1.PaidCurrency.MYR },
    { text: "NOK (ノルウェー・クローネ)", value: enum_1.PaidCurrency.NOK },
    { text: "NZD (ニュージーランド・ドル)", value: enum_1.PaidCurrency.NZD },
    { text: "PHP (フィリピン・ペソ)", value: enum_1.PaidCurrency.PHP },
    { text: "PLN (ポーランド・ズウォティ)", value: enum_1.PaidCurrency.PLN },
    { text: "RUB (ロシア・ルーブル)", value: enum_1.PaidCurrency.RUB },
    { text: "SEK (スウェーデン・クローナ)", value: enum_1.PaidCurrency.SEK },
    { text: "SGD (シンガポール・ドル)", value: enum_1.PaidCurrency.SGD },
    { text: "THB (タイ・バーツ)", value: enum_1.PaidCurrency.THB },
    { text: "TRY (トルコリラ)", value: enum_1.PaidCurrency.TRY },
    { text: "TWD (ニュー台湾ドル)", value: enum_1.PaidCurrency.TWD },
    { text: "VND (ベトナム・ドン)", value: enum_1.PaidCurrency.VND },
    { text: "ZAR (ランド)", value: enum_1.PaidCurrency.ZAR },
];
var options = (_a = {},
    _a[util_1.EnumKeys.BELONGS_TO] = [
        { text: (0, translate_1.fat)("自分の請求書"), value: "me" },
        { text: (0, translate_1.fat)("所属部門の請求書"), value: "department" },
    ],
    _a[util_1.EnumKeys.DETAIL_TAX_TYPE] = [
        { text: "外税", value: enum_1.DetailTaxType.EXCLUSIVE },
        { text: "内税", value: enum_1.DetailTaxType.INCLUSIVE },
    ],
    _a[util_1.EnumKeys.BILLED_FROM] = [
        { text: (0, translate_1.fat)("国内"), value: enum_1.BilledFrom.DOMESTIC },
        { text: (0, translate_1.fat)("海外"), value: enum_1.BilledFrom.OVERSEAS },
    ],
    _a);
var isAllowEmpty = (_b = {},
    _b[util_1.EnumKeys.DETAIL_TAX_TYPE] = false,
    _b[util_1.EnumKeys.BILLED_FROM] = true,
    _b[util_1.EnumKeys.PAID_CURRENCY] = true,
    _b);
var getEnumOptions = function (key) {
    if (key === util_1.EnumKeys.PAID_CURRENCY) {
        return globalThis.UILanguage === "en-US" ? englishCurrencies : japaneseCurrencies;
    }
    return options[key] || [];
};
exports.getEnumOptions = getEnumOptions;
var getEnumText = function (key, value) { var _a; return (0, fat_1.deFat)(((_a = (0, exports.getEnumOptions)(key).find(function (option) { return option.value === value; })) === null || _a === void 0 ? void 0 : _a.text) || ""); };
exports.getEnumText = getEnumText;
var isAllowEmptyEnum = function (key) { return isAllowEmpty[key] || false; };
exports.isAllowEmptyEnum = isAllowEmptyEnum;
exports.AUDIT_TRAIL_LABEL = (_c = {},
    _c[enum_1.AuditTrailAction.REQUEST] = (0, translate_1.fat)("承認依頼"),
    _c[enum_1.AuditTrailAction.APPROVE] = (0, translate_1.fat)("承認"),
    _c[enum_1.AuditTrailAction.FINAL_APPROVE] = (0, translate_1.fat)("最終承認"),
    _c[enum_1.AuditTrailAction.REJECT] = (0, translate_1.fat)("差し戻し"),
    _c[enum_1.AuditTrailAction.COMMENT] = (0, translate_1.fat)("コメント"),
    _c[enum_1.AuditTrailAction.RETRACT] = (0, translate_1.fat)("取り下げ"),
    _c);
